(function () {
  const NATIVE_STICKY_CLASSES = [
    "shopify-section-header-hidden",
    "shopify-section-header-sticky",
    "animate",
    "header--scrolled",
  ];

  let prevScrollY = window.scrollY;
  let ticking = false;
  let heroSection = null;

  /* =========================================================================
     FIX PARPADEO/SALTO EN SCROLL LENTO (agosto 2026)
     ---------------------------------------------------------------------
     PROBLEMA ORIGINAL: "goingUp" se calculaba comparando scrollY solo
     contra el valor del frame inmediatamente anterior, sin ningún margen
     de tolerancia:

         const goingUp = scrollY < prevScrollY;

     Al hacer scroll LENTO con rueda o trackpad es normal que scrollY
     tenga micro-retrocesos de 1-2px de un frame a otro (inercia/rebote
     del propio dispositivo de scroll). Cada uno de esos micro-retrocesos
     invertía "goingUp", y por tanto añadía/quitaba la clase
     "header--compact" muchas veces por segundo. Esa clase cambia
     position: sticky -> fixed y reduce el padding del header, así que
     cada toggle producía un salto de altura visible = el parpadeo del
     vídeo. Con scroll rápido no se notaba porque apenas hay tiempo de
     que el navegador pinte esos frames intermedios.

     SOLUCIÓN: histéresis. Exigimos que el scroll se haya movido al menos
     DIRECTION_BUFFER px de forma acumulada en la nueva dirección antes
     de confirmar un cambio de sentido. El scroll rápido no se ve
     afectado (supera el buffer en 1-2 frames de sobra); el scroll lento
     deja de parpadear porque los micro-retrocesos de 1-2px nunca llegan
     a superar el buffer.
  ========================================================================= */
  const DIRECTION_BUFFER = 10; // px de tolerancia antes de confirmar cambio de sentido
  let refY = window.scrollY; // referencia desde la que se mide el buffer
  let goingUpState = false;

  const updateDirection = (scrollY) => {
    const delta = scrollY - refY;
    if (goingUpState && delta > DIRECTION_BUFFER) {
      // Veníamos subiendo pero ya bajamos más de lo tolerado -> confirmar bajada
      goingUpState = false;
      refY = scrollY;
    } else if (!goingUpState && delta < -DIRECTION_BUFFER) {
      // Veníamos bajando pero ya subimos más de lo tolerado -> confirmar subida
      goingUpState = true;
      refY = scrollY;
    } else if (goingUpState && scrollY < refY) {
      // Seguimos subiendo de forma consistente: desliza la referencia
      refY = scrollY;
    } else if (!goingUpState && scrollY > refY) {
      // Seguimos bajando de forma consistente: desliza la referencia
      refY = scrollY;
    }
    // Si el movimiento es un micro-retroceso dentro del buffer, no se toca
    // goingUpState -> no hay toggle de clase -> no hay parpadeo.
    return goingUpState;
  };

  const findHeroSection = () => {
    const main = document.querySelector("main");
    heroSection =
      main &&
      main.querySelector(
        ".shopify-section:first-child:not(.not-margin) .section--has-overlay:not(.article-template__header)"
      );
  };

  const applyScrollState = () => {
    ticking = false;
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    header.classList.remove(...NATIVE_STICKY_CLASSES);

    const scrollY = window.scrollY;
    const goingUp = updateDirection(scrollY);
    prevScrollY = scrollY;

    if (scrollY < 80 && !!heroSection && heroSection.getBoundingClientRect().bottom > 80) {
      header.classList.add("entering-section", "color-background-2");
      header.classList.remove("header--compact");
      return;
    }

    header.classList.remove("entering-section", "color-background-2");

    if (scrollY < 40) {
      header.classList.remove("header--compact");
    } else if (goingUp) {
      header.classList.add("header--compact");
    } else {
      header.classList.remove("header--compact");
    }
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(applyScrollState);
    }
  };

  const onResize = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    findHeroSection();
  };

  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    header.classList.remove(...NATIVE_STICKY_CLASSES);

    const stickyHeaderEl = document.querySelector("sticky-header");
    if (stickyHeaderEl) stickyHeaderEl.removeAttribute("data-sticky-type");

    if (document.querySelector(".header-always")) header.classList.add("always-show");

    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector(".header__search");

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search && search.isOpen) search.close();
    });

    document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);

    const annBar = document.querySelector(".section-announcement");
    if (annBar && !annBar.dataset.annObserved) {
      annBar.dataset.annObserved = "1";
      new IntersectionObserver((entries) => {
        const [entry] = entries;
        document.documentElement.style.setProperty(
          "--ann-height",
          entry.isIntersecting ? `${entry.intersectionRect.height}px` : "0px"
        );
      }).observe(annBar);
    }

    // ===== HOVER EN ITEMS DE MENÚ =====
    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        if (header.classList.contains("color-background-2")) {
          header.classList.add("header--menu-hover");
        }
      });
      link.addEventListener("mouseleave", () => {
        header.classList.remove("header--menu-hover");
      });
    });

    // ===== ANIMACIÓN REVEAL SUBMENU =====
    document.querySelectorAll(".header__submenu").forEach((submenu) => {
      submenu.style.clipPath = "inset(0 0 100% 0)";
      submenu.style.transition = "clip-path 0.45s cubic-bezier(0.4, 0, 0.2, 1)";
      submenu.style.visibility = "hidden";
    });

    menuLinks.forEach((item) => {
      const submenu = item.querySelector(".header__submenu");
      if (!submenu) return;
      item.addEventListener("mouseenter", () => {
        submenu.style.visibility = "visible";
        submenu.style.clipPath = "inset(0 0 0% 0)";
      });
      item.addEventListener("mouseleave", () => {
        submenu.style.clipPath = "inset(0 0 100% 0)";
        setTimeout(() => {
          if (!item.matches(":hover")) submenu.style.visibility = "hidden";
        }, 450);
      });
    });

    const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
    const main = document.querySelector("main");
    if (main) {
      const firstShopifySection = main.querySelectorAll(".shopify-section")[0];
      if (
        firstShopifySection &&
        firstShopifySection.classList.contains("section--has-overlay") &&
        !firstShopifySection.classList.contains("not-margin")
      ) {
        header.classList.add("color-background-1", "color-background-2");
        if (breadcrumbs) breadcrumbs.classList.add("color-background-2");
      }
    }

    findHeroSection();
    applyScrollState();

    if (!window.__balentesHeaderScrollBound) {
      window.__balentesHeaderScrollBound = true;
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onResize, { passive: true });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeader);
  } else {
    initHeader();
  }

  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();